import { toast } from "react-toastify";
import * as options from "./options";
import "./styles.css";

export function ErrorData(result: any) {
  if (Array.isArray(result)) {
    result.forEach(function (item) {
      toast.error(item, {
        ...options.errorOptions,
        className: "toast-message-error",
        position: "top-left",
      });
    });
  } else {
    toast.error(result, {
      ...options.errorOptions,
      className: "toast-message-error",
      position: "top-left",
    });
  }
}

export function SuccessData(result: any) {
  toast.success(result, {
    ...options.successOptions,
    className: "toast-message-success",
    position: "top-left",
  });
}

export function WarningData(result: any) {
  toast.warning(result, {
    ...options.warningOptions,
    className: "toast-message-warning",
    position: "top-left",
  });
}

export function InfoData(result: any) {
  toast.info(result, {
    ...options.infoOptions,
    className: "toast-message-info",
    position: "top-left",
  });
}
